import React from 'react';
import './deposit-cancellation-policy.css';

export const hasCancellationPolicyContent = (cancellationPolicy) =>
  Boolean(cancellationPolicy?.refundPolicy?.trim());

const DepositCancellationPolicy = ({ cancellationPolicy, className = '' }) => {
  const refundPolicy = cancellationPolicy?.refundPolicy?.trim();

  if (!refundPolicy) {
    return null;
  }

  return (
    <div className={`deposit-cancellation-policy ${className}`.trim()}>
      <h4 className="deposit-cancellation-policy__title">Cancellation and refund policy</h4>
      <p className="deposit-cancellation-policy__text">{refundPolicy}</p>
    </div>
  );
};

export default DepositCancellationPolicy;
